import Navbar from '../components/Navbar';
import MenuComponent from '../components/Menu';
import Footer from '../components/Footer';

const Menu = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <MenuComponent />
      <Footer />
    </div>
  );
};

export default Menu;